import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Banner from './Banner';
import InsideContact from './InsideContact';


class TechTalk extends Component {
    omponentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div>
                <Banner
                    headText="Tech Talk"
                    subHeadText="Talks about technology"
                    subBoldText="INNOVATIVE. AFFORDABLE. PRACTICAL."
                    img="interior-1.jpg"
                />
                <div className="main-container">
                    <div className="container">
                        <div className="row">


                            <div className="col-lg-9 col-md-6 col-sm-12">
                                <h1>Business Continuity</h1>
                                <h4>What is it? And how can it bring your business to a new level?</h4>

                                {/*<p>
                                    As a business, it is common to have practices in place in case tragedy occurs - but what exactly are those practices?
                                     What would they protect against? How would they help your business? Would they allow your business to continue operation
                                     in the event that disaster struck? A good Business Continuity Plan will ask all of these questions, then answer them in complete detail.
                                </p>*/}
                                <p>
                                    A <strong>Business Continuity Plan</strong> is a process, typically defined by IT Support, that ensures all core operations and business
                                     functions are not severly impacted in the event of tragedy. This could be anything from a malware attack on your system,
                                     to a natural disaster (like a fire or tornado) destroying a physical location, to an accidental user error that wiped your system.
                                </p>
                                <p>
                                    Typically, data recovery is the first thing on mind should disaster strike. 
                                     It is crucial to not only have all your data backed up, but also have it stored in a way that is easily accessible from
                                     anywhere, in a safe and secure manner. Along with data, physical devices should be another concern -
                                     if your physical site gets destroyed, how long is it until you can get your hands on another device to continue
                                     working, given that your data is easily accessible? This process is called <strong>Disaster Recovery </strong>
                                     - a structured approach to recovery solutions needed for technology;
                                     and while it is a very important step in a Business Continuity Plan, it is not the only step that needs to be taken.
                                     Along with Disaster Recovery, a good BCP will address the following:
                                </p>
                                <p>
                                    <ul>
                                        <li>How you can continue servicing your customer</li>
                                        <li>How you can support your employees during an emergency</li>
                                        <li>Documentation and steps to ensure all company employees are aware and on board of the BCP</li>
                                        <li>Workaround procecess in the event that technology is not available to use as normal</li>
                                        <li>How to deal with procecess that are dependent on other business' that may be in the midst of disaster</li>
                                    </ul>
                                </p>
                                <p>&nbsp;</p>
                                <h4>A good BCP will take the following steps:</h4>
                                <ol>
                                    <li>Perform a <strong>Business Impact Analysis</strong> (BIA). A BIA will give you peace of mind in knowing what you can
                                         and cannot live without in the event of a tragedy. It will also give you a timeframe on how long you can
                                         afford to live with or without those items identified.</li>
                                    <li>Perform a <strong>Risk Assessment</strong>. This is the phase where you must double and triple check where things can go wrong.
                                         For instance, if you manage your own data and only store it in one location, you will lose all that data should
                                         something happen wherever it is being stored. You must have recovery options for everything.</li>
                                    <li>Account for and manage all risks. This is where a plan is developed to account for all things discussed above.
                                         Identifying problem areas is the first step. Now you must determine how to handle those problem areas.</li>
                                    <li>Lastly, you must test your plan. It is easy to just assume there are no gaps in your plan, but that is not guaranteed
                                         until it is tested. The last thing you will want is to realize there was an issue with your plan after you've already
                                         lost all of your crucial data.</li>
                                </ol>
                                <br /><br /><br />
                            </div>




                            <InsideContact />

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(TechTalk);


// WEBPACK FOOTER //
// ./src/components/TechTalk.js